import { useLanguage } from "@/context/LanguageContext";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

export default function Timeline() {
  const { t } = useLanguage();
  const tr = t.trayectoria;

  return (
    <section id="trayectoria" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-6 sm:py-28 lg:px-8" data-testid="trayectoria-section">
      <SectionHeader number={`${tr.number} · ${t.nav.trayectoria}`} title={tr.title} />

      <ol className="relative ml-3 border-l border-white/10 pl-8 sm:ml-6 sm:pl-12" data-testid="timeline-list">
        {tr.items.map((item, i) => (
          <li key={item.period} className="relative pb-12 last:pb-0">
            <span className="absolute -left-[37px] top-1 h-3 w-3 rounded-full border-2 border-sky-400 bg-[#07090E] sm:-left-[55px]" />
            <Reveal delay={0.08 * i}>
              <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-sky-400">
                {item.period}
              </p>
              <h3 className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                {item.club}
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">{item.text}</p>
              {item.source && (
                <p className="mt-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-600">
                  {item.source}
                </p>
              )}
            </Reveal>
          </li>
        ))}
      </ol>

      <Reveal delay={0.15} className="mt-14">
        <h3 className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.22em] text-sky-400">
          {tr.careerTitle}
        </h3>
        <div className="overflow-x-auto rounded-xl border border-white/10" data-testid="career-table">
          <table className="w-full min-w-[520px] text-left text-sm">
            <thead>
              <tr className="border-b border-white/10 bg-[#131927]">
                {tr.careerCols.map((col) => (
                  <th key={col} className="px-4 py-3.5 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tr.careerRows.map((row, i) => (
                <tr
                  key={row[0]}
                  className={`border-b border-white/5 last:border-0 ${i === tr.careerRows.length - 1 ? "bg-[#131927]/60" : "bg-[#0E131F]"}`}
                >
                  {row.map((cell, j) => (
                    <td
                      key={j}
                      className={`px-4 py-4 ${j === 0 ? "font-semibold text-slate-100" : "font-mono text-slate-300"} ${
                        i === tr.careerRows.length - 1 ? "text-sky-300" : ""
                      }`}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-slate-500">{tr.careerSource}</p>
        <p className="mt-1 text-xs leading-relaxed text-slate-600">{tr.careerNote}</p>
      </Reveal>
    </section>
  );
}
